import getRandomInt from "./getRandomInt";
import shaffleArray from "./shaffleArray";

const additionWithin10 = (numberOfProblems=10) => {
  const problemId = "additionWithin10";
  const problemDescription = "Addition within 10";
  const problems = [];
  for (let i=0; i<numberOfProblems; i++) {
    problems.push(generateOneProblem());
  }

  return { problemId, problemDescription, problems };
}

const generateOneProblem = () => {
  const whole = getRandomInt(11);
  const part1 = getRandomInt(whole+1);
  const part2 = whole - part1;
  const draw = {part1, part2, operation: "+"}
  const question = part1 + " + " + part2 + " = ____";
  const answer = whole;
  const statement = "What is the answer to this problem?"
  const choiceSet = new Set();
  choiceSet.add(whole);
  while (choiceSet.size < 4) {
    choiceSet.add(getRandomInt(11));
  }
  const choices = shaffleArray(Array.from(choiceSet));
  
  return { statement, question, answer, choices, draw };
}

export default additionWithin10;